import { memo } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import moment from "moment";
import images from "../../common/images";
import { formatTimeRange } from "../../utils/common";
import FavouriteIcon from "../FavouriteIcon";
import EventArtistCaption from "../EventArtistsCaption";
import ImageWithSkeleton from "../ImageWithSkeleton";
import { getEventClub } from "../../utils/eventClub";
import { getClubPath, getArtistPath, getEventPath } from "../../utils/clubPath";

const Card = ({
  club,
  artist,
  event,
  index,
  isLoading,
  city,
}) => {
  const renderGenericCard = (data, type) => {
    const dataClub = type === "event" ? getEventClub(data) : null;
    const link =
      type === "club"
        ? getClubPath(data, city || data?.city)
        : type === "event"
        ? getEventPath(data, city || data?.city)
        : getArtistPath(data);
    const image =
      type === "club"
        ? Array.isArray(data?.media?.ambienceImages) &&
          data?.media?.ambienceImages.length
          ? data.media.ambienceImages[0]
          : images.background
        : type === "event"
        ? Array.isArray(data?.images) && data?.images?.length && data?.images[0]
          ? data?.images[0]?.path
          : images.background
        : Array.isArray(data?.images) && data?.images.length
        ? data.images[0]
        : images.background;

    return (
      <>
        {(type === "club" || type === "artist") ? (
          <FavouriteIcon
            endpoint={`api/user/likes/${type === "club" ? "clubs" : "artists"}/${data?._id}`}
            item={data}
            isLiked={!data?.meta?.isLiked}
          />
        ) : (
          <FavouriteIcon
            endpoint={`api/user/likes/events/${data?._id}`}
            item={data}
            isLiked={!data?.meta?.isLiked}
          />
        )}
        <Link to={link}>
          <div className="img-sec">
            <ImageWithSkeleton
              src={image}
              alt={`${type} image`}
              className="img-fluid"
              skeletonHeight={300}
            />
          </div>
          <div className="text-sec">
            <div className="cnt-sec">
              {type === "event" ? (
                <>
                  <h4>{data?.title}</h4>
                  <p className="p-20">
                    {formatTimeRange(data?.eventStartTime, data?.eventEndTime)}
                  </p>
                  {data?.description ? (
                    <p className="p-20">{data.description}</p>
                  ) : null}
                  <p className="p-20">
                    {dataClub?.name}{" "}
                    {[dataClub?.locality || "", data?.address?.city || dataClub?.city || ""]
                      .filter((e) => e)
                      .join(", ")}
                  </p>
                  {data?.price?.amount ? (
                    <p className="p-20">
                      {"₹" + data?.price?.amount + " Onwards"}
                    </p>
                  ) : null}
                </>
              ) : (
                <h4>{data?.name}</h4>
              )}
            {type === "club" ? (
              <>
                {data?.category ? <p className="mb-0">{data.category}</p> : <p className="mb-0">Restrobar</p>}
                {(data?.locality || data?.city) && (
                  <p className="mb-0">
                    {[data?.locality, data?.city].filter(Boolean).join(", ")}
                  </p>
                )}
              </>
            ) : (
                <>
                  {data?.type ? (
                    <p className="mb-0">
                      {data?.type?.toLowerCase() === "artist"
                        ? "SINGER"
                        : data?.type?.toUpperCase()}
                    </p>
                  ) : null}
                  <p className="mb-0">{data?.musicGenre}</p>
              </>
            )}
          </div>
            {type === "club" ? (
              <div className="right-sec">
                {data?.zomatoRating ? (
                  <div className="rating-sec">
                    <p>
                      <i className="fa fa-star"></i>
                      {data?.zomatoRating}
                    </p>
                  </div>
                ) : null}
                {data?.cost ? (
                  <div className="price-sec">
                    <p>₹{data?.cost}</p>
                  </div>
                ) : null}
              </div>
            ) : null}
          </div>
        </Link>
      </>
    );
  };

  const renderEventCard = (event) => {
    const club = getEventClub(event);

    return (
    <div className="col-lg-3 " data-wow-delay="0.3s" key={index}>
      <div className="card event-card-item">
        <div className="date">
          <h2 className="date-text">
            {moment(event?.eventStartTime).format("DD")}
          </h2>
          <p className="date-month">
            {moment(event?.eventStartTime).format("MMM YYYY")}
          </p>
        </div>
        <FavouriteIcon
          endpoint={`api/user/likes/events/${event?._id}`}
          item={event}
          isLiked={!event?.meta?.isLiked}
        />
        <div >
          <div className="img-sec">
            <Link to={getEventPath(event)}>
            <img
              src={
                Array.isArray(event?.images) &&
                event?.images?.length &&
                event?.images[0] &&
                typeof event?.images[0]?.path == "string"
                  ? event?.images[0]?.path
                  : images.background
              }
              className="img-fluid"
              alt="img"
            />
            </Link>
          </div>
          <div className="event-heading">
            <h4 className="">{event?.title}</h4>
            <EventArtistCaption event={event} artists={event?.artists} />
            <p className="p-20">
              {formatTimeRange(event?.eventStartTime, event?.eventEndTime)}
            </p>
            {event?.description && <p className="p-20">{event.description}</p>}
            <p className="p-20">
              {club?.name}{" "}
              {[club?.locality || "", event?.address?.city || club?.city || ""]
                .filter((e) => e)
                .join(", ")}
            </p>
            {event?.price?.amount ? (
              <p className="p-20">{"₹" + event?.price?.amount + " Onwards"}</p>
            ) : null}
          </div>
        </div>
      </div>
    </div>

  );
  };

  return !event ? (
    <div
      className="col-lg-6 col-xl-3 wow fadeInUp"
      data-wow-delay="0.3s"
      key={index.toString()}
    >
      <div className="card">
        <div className="item">
          {isLoading ? (
            <>
              <div className="img-sec">
                <Skeleton height={300} />
              </div>
              <div className="text-sec">
                <div className="cnt-sec">
                  <h4>
                    <Skeleton width={100} />
                  </h4>
                  <p className="mb-0">
                    <Skeleton width={80} />
                  </p>
                  <p className="mb-0">
                    <Skeleton width={120} />
                  </p>
                </div>
                <div className="right-sec">
                  <div className="price-sec">
                    <p>
                      <Skeleton width={50} />
                    </p>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              {club && renderGenericCard(club, "club")}
              {artist && renderGenericCard(artist, "artist")}
            </>
          )}
        </div>
      </div>
    </div>
  ) : (
    renderEventCard(event)
  );
};

const MemoizedCard = memo(Card);
MemoizedCard.displayName = "Card";

export default MemoizedCard;

Card.propTypes = {
  club: PropTypes.shape({
    _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    locality: PropTypes.string,
    city: PropTypes.string,
    distance: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    distanceKm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    zomatoRating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    cost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    media: PropTypes.shape({
      ambienceImages: PropTypes.arrayOf(PropTypes.string),
    }),
  }),
  artist: PropTypes.shape({
    _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  event: PropTypes.shape({
    _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    description: PropTypes.string,
    eventStartTime: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    eventEndTime: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    images: PropTypes.arrayOf(
      PropTypes.shape({
        path: PropTypes.string,
      })
    ),
    meta: PropTypes.shape({
      isLiked: PropTypes.bool,
    }),
    club: PropTypes.shape({
      name: PropTypes.string,
      locality: PropTypes.string,
    }),
    address: PropTypes.shape({
      city: PropTypes.string,
    }),
    price: PropTypes.shape({
      amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    artists: PropTypes.array,
    type: PropTypes.string,
    musicGenre: PropTypes.string,
  }),
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isLoading: PropTypes.bool,
  city: PropTypes.string,
};
